import classnames from 'classnames'

import { useCompactOnOverflow } from '../../compactLayout'

import styles from './AgentBody.module.scss'

export type AgentBodyProps = {
  className?: string
}

export const AgentBody: React.FC<React.PropsWithChildren<AgentBodyProps>> = ({
  children,
  className,
}) => {
  const compactTriggerRef = useCompactOnOverflow('agent-body')
  return (
    <div ref={compactTriggerRef} className={classnames(styles.root, className)}>
      {children}
    </div>
  )
}
